module.exports = __webpack_public_path__ + "static/media/ck.c30e9544.svg";